<template>
	<div class="land-flats-cards-filter land-flats-cards-filter-kohota" v-if="salesCardPage != null && salesCardPage.land_flats_cards_info != null">
		<!-- {{this.salesCardFlats}} -->
		<div class="btns-cards-filter">
			<ul>
				<li>
					<a href="#" :disabled="gClass === 'all'" @click.prevent="reloadFilter">
						<p>{{salesCardPage.land_flats_cards_info.all}}</p>
						<span class="count">{{salesCardFlatsDefault.length}}</span>
					</a>
				</li>
				<li v-if="count_one > 0">
					<a href="#" :disabled="gClass === 'one'" @click.prevent="initFilterFlats(1, 'one')">
						<p class="title">1<span>{{salesCardPage.land_flats_cards_info.flat_name}}</span></p>
						<span class="count">{{count_one}}</span>
					</a>   
				</li>
				<li v-if="count_half_two > 0">
					<a href="#" :disabled="gClass === 'half_two'" @click.prevent="initFilterFlats(1.5, 'half_two')">
						<p class="title">1,5<span>{{salesCardPage.land_flats_cards_info.flat_name}}</span></p>
						<span class="count">{{count_half_two}}</span>
					</a>   
				</li>
				<li v-if="count_two > 0">
					<a href="#" :disabled="gClass === 'two'" @click.prevent="initFilterFlats(2, 'two')">
						<p class="title">2<span>{{salesCardPage.land_flats_cards_info.flat_name}}</span></p>
						<span class="count">{{count_two}}</span>
					</a>   
				</li>
				<li v-if="count_three > 0">
					<a href="#" :disabled="gClass === 'three'" @click.prevent="initFilterFlats(3, 'three')">
						<p class="title">3<span>{{salesCardPage.land_flats_cards_info.flat_name}}</span></p>
						<span class="count">{{count_three}}</span>
					</a>  
				</li>
				<li v-if="count_four > 0">
					<a href="#" :disabled="gClass === 'four'" @click.prevent="initFilterFlats(4, 'four')">
						<p class="title">4<span>{{salesCardPage.land_flats_cards_info.flat_name}}</span></p>
						<span class="count">{{count_four}}</span>
					</a>  
				</li>
			</ul>
		</div>
		<div class="btns-cards-view btns-cards-view-aqualina">
			<p>{{salesCardPage.land_flats_cards_info.view_title}}</p>
			<div class="btns">
				<div class="item" :class="{active: !gridView}">
					<a href="#" class="btn-view-list btn-change-cards-view"@click.prevent="setListView">
						<svg-icon icon-class="list" className="icon-list"/>
					</a>
				</div>
				<div class="item" :class="{active: gridView}">
					<a href="#" class="btn-view-grid btn-change-cards-view" @click.prevent="setGridView">
						<svg-icon icon-class="grid" className="icon-grid"/>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'
	export default {
		name: 'flat-filter',
        props: ['cardsItems'],
		components: {
		},
		data () {
			return {
				filterList: [],
				itemsListVisible: false,
				count_one: null,
				count_half_two: null,
				count_two: null,
				count_three: null,
				count_four: null,
				gClass: 'all',
			}
		},
		computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
			salesCardFlats: 'loadFlatsCardsGlobal',
            salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
			gridView: 'loadLandFlatsGridView',
            activeFlats: 'loadActiveFlatsClassKohOta',
        }),
		methods: {
			filterlist() {
				var data = this.salesCardFlatsDefault;
                var one = data.filter(item => {
                    return item.room == 1
                });
				var half_two = data.filter(item => {
                    return item.room == 1.5
                });
                var two = data.filter(item => {
                    return item.room == 2
                });
                var three = data.filter(item => {
                    return item.room == 3
                });
                var four = data.filter(item => {
                    return item.room == 4
                });
                this.count_one = one.length;
				this.count_half_two = half_two.length;
                this.count_two = two.length;
                this.count_three = three.length;
                this.count_four = four.length;

                // console.log(this.count_one, this.count_two, this.count_three, this.count_four, 'TEST BUILD')
			},
			initFilterFlats(count, param) {
				this.gClass = param;
				this.$store.commit('animateCards', false);
				var filteredItems = this.salesCardFlatsDefault.filter(item => {
					return parseFloat(item.room) == count
				});
				console.log(count, param, filteredItems, 'ADADASD');
				this.$store.dispatch('clearFlatCardAll', filteredItems);
				setTimeout(()=>{
					this.$store.commit('animateCards', true);
				},50);
            },
            reloadFilter() {
				this.gClass = 'all';
                this.$store.dispatch('clearFlatCardAll', this.salesCardFlatsDefault);
            },
            setListView() { 
				this.$store.commit('gridView', false);
            },
            setGridView() {
				this.$store.commit('gridView', true);
            }
		},
		mounted() {
			this.filterlist();
			this.$store.watch(
                (state) => state.flatsCardsGlobalDefault,
                (newValue) => {
					if (newValue) 
            		this.filterlist();
                }
            )
		}
	}
</script>

<style lang="scss" scoped>
	// @import '@/styles/components/flats/filter.scss';
	@import '@/styles/components/sales/sales-land-partials/land-flats-filter.scss';
	@import '@/styles/respond/sales/sales-land-partials/flats-partials/flat-filter-respond.scss';
	// @import '@/styles/components/flats/flats-respond/filter-respond.scss';
	// @import '@/styles/components/animation/animation-flat.scss';
</style>